export enum ClassStatus {
  New = 'new',
  Open = 'open',
  Closed = 'closed',
}

export enum StudentLessonStatus {
  NotAttended = 'not_attended',
  Attended = 'attended',
  Withdrawn = 'withdrawn',
  Suspended = 'suspended',
}

export enum TransferClassStatus {
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
}
